import { useRef, useEffect, UIEvent } from 'react';
import { TestimonialLarge } from '../../../types/testimonial';

type Props = {
  testimonials: TestimonialLarge[];
}

const TestimonialLargeGallery = ({ testimonials }: Props) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const duplicated = [...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials, ...testimonials];

  // On mount, set scroll position to the midpoint
  useEffect(() => {
    if (scrollRef.current) {
      const container = scrollRef.current;
      container.scrollLeft = container.scrollWidth / 3;
    }
  }, [testimonials]);

  // Handle scroll to create infinite effect
  // const onScroll = (e: UIEvent<HTMLDivElement>) => {
  //   const container = e.currentTarget;
  //   const half = container.scrollWidth / 2;
  //   if (container.scrollLeft <= 0) {
  //     container.scrollLeft += half;
  //   } else if (container.scrollLeft >= half) {
  //     container.scrollLeft -= half;
  //   }
  // };

  return (
    <div className="row justify-content-center align-items-center pb-4">
      <div className="col-md-7 col-12">
        <div className="row justify-content-center align-items-center"></div>
        <div className="iiscroller-wrapper" >
          <div
            className="iiscroller-container"
            ref={scrollRef}
            // onScroll={onScroll}
          >
            {duplicated.map((testimonial, idx) => (
              <div className="col-md-3 col-6 px-1 py-2 text-center" key={idx}>
                <picture>
                  <source srcSet={testimonial.imgWebp} type="image/webp" />
                  <img className="img-fluid rounded gg-img-customer-gallery iiscroller-image" src={testimonial.img} loading="lazy" />
                </picture>
              </div>
            ))}
          </div>
          {/* Fade overlays to hint scrollability */}
          <div className="iiscroller-fade fade-left" />
          <div className="iiscroller-fade fade-right" />
        </div>
      </div>
    </div>
  );
};

export default TestimonialLargeGallery;
